import axios from 'axios';
import backendUrl from '../backendUrl';
import { setConfig } from './auth';
import { ContactPayload, SitePayload } from '../redux/types';

const baseUrl = `${backendUrl}/sites`;
const concUrl = `${backendUrl}/concentrateurs`;

const getSites = async () => {
  const response = await axios.get(baseUrl, setConfig());
  return response.data;
};

const getSitesSn = async (siteSn: string) => {
  const response = await axios.get(`${backendUrl}/site/${siteSn}`, setConfig());
  return response.data;
};

const getSitesBySn = async (siteSn: string) => {
  console.log("AIE CARAMBA #####################################")
  const response = await axios.get(`${backendUrl}/logement/${siteSn}`, setConfig());
  return response.data;
};

const getSiteBySiteId = async (siteId: string) => {
  console.log(siteId);
  const response = await axios.get(`${backendUrl}/sites/site/${siteId}`, setConfig());
  return response.data;
};

const createSite = async (theContact: ContactPayload, siteData: SitePayload) => {
  const data = { theContact, siteData }
  const response = await axios.post(`${backendUrl}/sites/addsite/`, data, setConfig());
  return response.data;
};

const modifySite = async (siteId: string, siteData: SitePayload) => {
  const response = await axios.put(
    `${baseUrl}/site/${siteId}`,
    siteData,   //{ data: siteData },
    setConfig()
  );
  return response.data;
};
// TODO: bien faire la diff (change le slice) pour l'action MODIFY (modifier une vue existante) et l'action UPDATE (créer nvelle vue)
const updateSite = async (siteId: string, siteData: SitePayload) => {
  const response = await axios.post(
    `${baseUrl}/site/${siteId}`,
    siteData,   //{ data: siteData },
    setConfig()
  );  //TODO: retourner également le contact lié contenant l'id du nouveau site
  return response.data;
};

const updateNote = async (siteId: string, siteData: { siteNote: string, date_update: string }) => {
  const response = await axios.put(
    `${baseUrl}/notes/${siteId}`,
    { data: siteData },//siteNote,
    setConfig()
  ); 
  return response.data;
};

const createNote = async (siteId: string, siteData: { siteNote: string, date_update: string }) => {
  const response = await axios.post(
    `${baseUrl}/notes/${siteId}`,
    { data: siteData },
    setConfig()
  );
  return response.data;
};

const updateConcentrateur = async (siteId: string, infos: { action: string, concSn: string, concentrateurSn: string, concentrateurId: string,
  dateChgmt: string, siteId: string, siteSn: string, tel: string, techno: string, modules: string }) => {
  const response = await axios.put(
    `${concUrl}/${siteId}/updconcentrateur/`,
    { infos: infos },//siteNote,
    setConfig()
  ); 
  return response.data;
};

const stopConcentrateur = async (siteId: string, infos: { action: string, concSn: string, concentrateurSn: string, concentrateurId: string,
  dateChgmt: string, siteId: string, siteSn: string, tel: string, techno: string, modules: string }) => {
  const response = await axios.put(
    `${concUrl}/${siteId}/stopconcentrateur/${infos.concentrateurId}`,
    { dateChgmt: infos.dateChgmt, siteSn: infos.siteSn },
    setConfig()
  ); 
  return response.data;
};

const telConcentrateur = async (siteId: string, infos: { action: string, concSn: string, concentrateurSn: string, concentrateurId: string,
  dateChgmt: string, siteId: string, siteSn: string, tel: string, techno: string, modules: string }) => {
  const response = await axios.put(
    `${concUrl}/${siteId}/telconcentrateur/${infos.concentrateurId}`,
    { tel: infos.tel, techno: infos.techno },
    setConfig()
  ); 
  return response.data;
};

const replaceConcentrateur = async (siteId: string, infos: { action: string, concSn: string, concentrateurSn: string, concentrateurId: string,
  dateChgmt: string, siteId: string, siteSn: string, tel: string, techno: string, modules: string }) => {
  const response = await axios.post(
    `${concUrl}/${siteId}/replaceconcentrateur/${infos.concentrateurId}`,
    { dateChgmt: infos.dateChgmt, tel: infos.tel, siteSn: infos.siteSn, concSn: infos.concSn },
    setConfig()
  ); 
  return response.data;
};

const addConcentrateur = async (siteId: string, infos: { action: string, concSn: string, concentrateurSn: string, concentrateurId: string,
  dateChgmt: string, siteId: string, siteSn: string, tel: string, techno: string, modules: string }) => {
  const response = await axios.post(
    `${concUrl}/${siteId}/addconcentrateur/`,
    { tel: infos.tel, dateChgmt: infos.dateChgmt, concentrateurSn: infos.concSn, siteSn: infos.siteSn },//siteNote,
    setConfig()
  ); 
  return response.data;
};

const addModule = async (siteId: string, concId: number, modSn: string ) => {
  const response = await axios.post(
    `${concUrl}/${siteId}/addmodule/${concId}`,
    { modSn: modSn },
    setConfig()
  ); 
  return response.data;
};

const replaceModule = async (siteId: string, concId: number, prevModSn: string, newModSn: string, dateChgmt: string, siteSn: string ) => {
  const response = await axios.put(
    `${concUrl}/${siteId}/replacemodule/${concId}`,
    { prevModSn: prevModSn, newModSn: newModSn, dateChgmt: dateChgmt, siteSn: siteSn },
    setConfig()
  ); 
  return response.data;
};

const stopModule = async (siteId: string, concId: number, modSn: string, dateStop: string, siteSn: string ) => {
  const response = await axios.put(
    `${concUrl}/${siteId}/stopmodule/${concId}`,
    { modSn: modSn, dateStop: dateStop, siteSn: siteSn },
    setConfig()
  ); 
  return response.data;
};

const deleteSite = async (siteId: string) => {
  const response = await axios.delete(`${baseUrl}/${siteId}`, setConfig());
  return response.data;
};

const editSiteSn = async (siteId: string, newSN: string) => {
  const response = await axios.put(
    `${baseUrl}/${siteId}`,
    { name: newSN },
    setConfig()
  );
  return response.data;
};

const updateLegendes = async (siteSn: string) => {
  const response = await axios.post(`${baseUrl}/legendes/update/${siteSn}`, {}, setConfig());
  return response.data;
};

const siteService = {
  getSites,
  getSitesSn,
  getSitesBySn,
  getSiteBySiteId,
  createSite,
  modifySite,
  updateSite,
  deleteSite,
  createNote,
  updateNote,
  addConcentrateur,
  telConcentrateur,
  stopConcentrateur,
  replaceConcentrateur,
  updateConcentrateur,
  addModule,
  replaceModule,
  stopModule,
  editSiteSn,
  updateLegendes,
};

export default siteService;
